interface MessageBubbleProps {
  role: 'assistant' | 'candidate';
  content: string;
}

export function MessageBubble({ role, content }: MessageBubbleProps): React.ReactNode {
  const isAssistant = role === 'assistant';

  return (
    <div className={`flex ${isAssistant ? 'justify-start' : 'justify-end'}`}>
      <div
        className={`max-w-[85%] rounded-2xl px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap ${
          isAssistant
            ? 'rounded-bl-md bg-card shadow-sm border border-border text-foreground'
            : 'rounded-br-md bg-primary text-primary-foreground'
        }`}
      >
        {content}
      </div>
    </div>
  );
}
